
// База API берётся из переменной окружения REACT_APP_API_URL (см. .env в корне).
// По умолчанию — относительный путь /platform/api: браузер ходит на тот же домен,
// а перенаправлением на реальное API занимается прокси (dev — setupProxy.js,
// прод — server.js). Это убирает проблемы с CORS. Чтобы поменять адрес API,
// правьте .env (переменную API_UPSTREAM), а НЕ этот файл.
const ENV_API_URL = (process.env.REACT_APP_API_URL || '').trim();

export const API_URL = ENV_API_URL
  ? ENV_API_URL
  : (process.env.NODE_ENV === 'development'
      ? '/platform/api'                          // dev: относительный путь через прокси
      : 'https://geoindicator.ru/platform/api'); // страховочный фолбэк для боевой сборки

export const LS_KEYS = {
    token: 'accessToken',
    refreshToken: 'refreshToken',
    userInfo: 'userInfo',
    projectData: 'projectData',
} as const;